import { mapActions, mapState } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import register from './register';
import { unformats } from '../common/format';
import AgentHeadShot from "@/components/agent-headshot.vue"
import { INTERCEPT_URL } from '@/common/customize';
import { getPhysicalInfo } from '@/common/getPhysicalInfo.js'

export default {
    mixins: [register],
    components: {
        AgentHeadShot
    },
    computed: {
        ...mapState(usePageStore, ['page'])
    },
    methods: {
        ...mapActions(useUserStore, ['updateUser']),
        ...mapActions(usePageStore, ['getCustomParams']),
        registerSubmitSuccess(data = {}) {
            if (this.disclaimerSubmitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            this.formatData(data);
            if (this.user) {
                if (this.data.question) {
                    return this.leaveMessage(this.onSuccessCallback);
                } else if (this.data.phoneNumber) {
                    return this.updatePhone(this.data.phoneNumber);
                } else {
                    this.submitDisabled = false;
                }
            } else {
                return this.leadRegister();
            }
        },
        leadAutoRegister(data, option) {
            this.formatData(data);
            this.submitRegisterInfo(option && option.virtualHouseInfo, true);
        },
        async updatePhone(phoneNumber, callback) {
            phoneNumber = unformats.number(phoneNumber);
            if (this.user.phoneNumber === phoneNumber) {
                this.submitDisabled = false;
                return;
            }
            // TCPA consent
            let customParams = this.getCustomParams(INTERCEPT_URL.updatePhone);
            let physicalInfo = await getPhysicalInfo();
            customParams.physicalInfo = physicalInfo;
            const params = {
                phoneNumber,
                ...customParams
            }
            this.axiosIns
                .post('/api-site/profile/update/phoneNumber', params)
                .then(() => {
                    this.updateUser({ phoneNumber });
                    callback && callback();
                    this.submitDisabled = false;
                });
        },
        leaveMessage(callback) {
            let data = {};
            this.data.tag && (data.tagIds = this.data.tag); //SITE-12720,tagIds parameters passed to the backend 
            data.note = this.data.note || '';
            data.pageUrl = window.location.href;
            data.pageUri = window.location.href;
            data.question = this.data.question || '';
            if (this.data.meetTime) {
                data.meetTime = this.data.meetTime;
            }
            if (this.data.address) {
                data.address = this.data.address;
            }
            // listingId and isSoldListing  rear end GlobalData Give 
            if (this.page.listingId !== undefined) {
                data.listingId = this.page.listingId;
            }
            if (this.page.isSoldListing !== undefined) {
                data.sold = this.page.isSoldListing;
            }
            data.otherMsg = this.page.page || '';
            data.name = this.data.fullname || this.user.fullName || '';
            data.phoneNum = unformats.number(
                this.data.phone || this.user.phoneNumber || ''
            );
            data.emailAddress = this.data.email || this.user.account || '';
            if (this.options && this.options.questionFormat) {
                Object.assign(data, {
                    question: this.options.questionFormat(data.question)
                });
            }
            if (typeof this?.leaveMessageParamsFormat === 'function') {
                data = this.leaveMessageParamsFormat(data);
            }
            this.axiosIns
                .post('/api-site/leaveMsg', data)
                .then(() => {
                    if (
                        data.phoneNum &&
                        this.user &&
                        this.user.phoneNumber !== data.phoneNum
                    ) {
                        this.updateUser({ phoneNumber: data.phoneNum });
                    }
                    callback && callback(data);
                    // this.submitDisabled = false;
                })
                .catch(e => {
                    console.log(e);
                    // this.submitDisabled = false;
                });

            this.$EventBus.$emit('siteTrack', {
                msg: data.question,
                trackType: 'leave-message'
            });
        }
    }
};
